import Spreadsheet from './spreadsheet'

/**
 * @class XLSXSpreadsheet
 * @extends {Spreadsheet}
 */
export default class XLSXSpreadsheet extends Spreadsheet {
    constructor() {
        super()
        this.XLSX = require('xlsx') //eslint-disable-line global-require
    }
    read(data) {
        const workBook = this.XLSX.read(data, { type: (typeof data === 'string') ? 'binary' : 'array' })
        return this.XLSX.utils.sheet_to_json(workBook.Sheets[workBook.SheetNames[0]], { header: 1 })
    }
}
